import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  defaultLimitPagination,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../../components/Pagination";
import { debounce } from "lodash";
import MainBody from "../../../../components/MainBody/MainBody";
import sortCaret from "../../../../components/SortCaret";
// import { Button } from "../../../../components/ui/button";
import { useOrganization } from "../../../../lib/context/OrganisationContext";
import PolicyActionButton from "./PolicyActionButton";
import { formatSubcontractorName } from "../../../../lib/Misc";
// import ExpandPolicies from "./ExpandPolicies";
// import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";

// * Start: Vendor Listing Page
const Policies = () => {
  // * Start: Url Management State
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");

  // * End: Url Management State

  // * Start: List Management State

  const { organizationData } = useOrganization();
  const [policiesList, setPoliciesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  // * End: List Management State

  /**
   * * Start: Fetch Vendor List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Vendor List
   **/

  const fetchPolicies = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_POLICIES}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }`,
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const policiesList = data.data.data;
        setPoliciesList(policiesList);
        return data.data;
      } catch (error) {
        setPoliciesList([]);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField, organizationData?.organizationId],
  );

  //* End: Fetch Vendor List Form The API

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of Policies)
   * @returns {Array} Vendor List
   **/

  const policiesGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: policiesList[i]?.id,
        id: policiesList[i]?.id ? policiesList[i]?.id : "",
        year: policiesList[i]?.year ? policiesList[i]?.year : "",
        aml_ctf_version: policiesList[i]?.aml_ctf_version
          ? `Y${policiesList[i]?.year} (V${policiesList[i]?.aml_ctf_version})`
          : "",
        version: policiesList[i]?.version ? policiesList[i]?.version : "",
        date: policiesList[i]?.created_at ? policiesList[i]?.created_at : "",
        name: policiesList[i]?.name ? policiesList[i]?.name : "",
        next_review_date: policiesList[i]?.next_review_date
          ? policiesList[i]?.next_review_date
          : "",
        approved_date: policiesList[i]?.approved_date
          ? policiesList[i]?.approved_date
          : "",
        approved_by: policiesList[i]?.approved_by
          ? formatSubcontractorName(policiesList[i]?.approved_by)
          : "",
        compliance_manager: policiesList[i]?.compliance_manager
          ? `${policiesList[i]?.compliance_manager?.first_name || ""} ${
              policiesList[i]?.compliance_manager?.last_name || ""
            }`
          : "",
        status: policiesList[i]?.uploaded ? 'Uploaded' : "Draft",
        expandData: policiesList[i]?.policies ? policiesList[i]?.policies : [],
        action: (
          <PolicyActionButton
            id={policiesList[i]?.id}
            item={policiesList[i]}
            fetchPolicies={() => fetchPolicies()}
            approved={policiesList[i]?.approved}
            setLoading={setLoading}
            approvalPremission={
              policiesList[i]?.approval_permission
                ? policiesList[i]?.approval_permission
                : ""
            }
          />
        ),
      });
    }
    return items;
  };

  const policies = policiesGenerator(policiesList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      dataField: "year",
      text: "Year",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "aml_ctf_version",
      text: "AML/CTF Version",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    // {
    //   dataField: "version",
    //   text: "Version",
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    // },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "next_review_date",
      text: "Next Review Date",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "approved_date",
      text: "Approved Date",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "approved_by",
      text: "Approved By",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "compliance_manager",
      text: "Compliance Manager",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "status",
      text: "Status",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  /**
   * * Start: Vendor List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Vendor List Sorting

  /**
   * * Start: Vendor List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchPolicies(limit, 1);
  };

  //* End: Vendor List Change Limit

  /**
   * * Start: Vendor List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchPolicies(limit, page);
  };

  //* End: Vendor List Change Page

  //* Start: Vendor List and URL Mangement useEffect

  useEffect(() => {
    fetchPolicies();
  }, [fetchPolicies]);

  //* End: Vendor List and URL Mangement useEffect

  //* Start: Vendor List Search Record Management

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  // const handleDownload = async () => {
  //   try {
  //     setLoading(true);
  //     let api = `${API.DOWNLOAD_POLICIES_TEMPLATE}`;
  //     const { data } = await get(api);
  //     const export_report_path = data?.data?.file;
  //     if (export_report_path) {
  //       var a = document.createElement("a");
  //       a.href = export_report_path;
  //       var file = export_report_path.split("/");
  //       a.target = "_blank";
  //       a.setAttribute("download", file[file.length - 1] || "contractor.xls");
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       setLoading(false);
  //     }
  //     setLoading(false);
  //   } catch (e) {
  //     setLoading(false);
  //   }
  // };

  //* End: Vendor List Search Record Management

  useEffect(() => {
    navigate(
      `?tab=program&childTab=policies&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, page]);

  // const expandRow = {
  //   renderer: (row) => (
  //     <>
  //       <ExpandPolicies expandData={row?.expandData} />
  //     </>
  //   ),
  //   onlyOneExpanding: false,
  //   showExpandColumn: true,
  //   expandByColumnOnly: true,
  //   headerClasses: THClasses,
  //   expandColumnRenderer: ({ expanded }) => {
  //     if (expanded) {
  //       return <CaretDownIcon />;
  //     }
  //     return <CaretRightIcon />;
  //   },
  //   className: TDClasses,
  //   expandHeaderColumnRenderer: () => {
  //     return <></>;
  //   },
  // };

  return (
    <MainBody
      searchParamData={searchParamData}
      handleClearSearch={handleClearSearch}
      handleSearchChange={handleSearchChange}
      actionContent={
        <>
          {/* <Button
            onClick={() => {
              handleDownload();
            }}
          >
            Download Draft
          </Button> */}
        </>
      }
      loading={loading}
      innerBody={true}
      parentHeight={true}
      mainClassName="w-[calc(100%-3rem)]"
    >
      {/* Vendor Table and Pagination */}
      <div className="custom-table">
        <div className="table-body-class">
          <BootstrapTable
            keyField="key"
            remote
            data={policies}
            columns={columns}
            onTableChange={handleTableChange}
            // expandRow={expandRow}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>
    </MainBody>
  );
};

export default Policies;
// * End: Vendor Listing Page
